export default {
  warning: {
    summary: 'Nieobsługiwany skład materiału',
    details: 'Obliczanie wykresów CTPc jest obecnie ograniczone do materiałów, w których procentowy udział wagowy wszystkich pierwiastków jest mniejszy niż {threshold}.',
  },
};
